import React from 'react';
import LinkedinIcon from './Linkedin.icon';
import TelegramIcon from './Telegram.icon';
import MsTeamsIcon from './MsTeams.icon';

export enum PersonLinksIcons {
  LINKEDIN = 'LINKEDIN',
  TELEGRAM = 'TELEGRAM',
  MS_TEAMS = 'MS_TEAMS',
}

const ICON_SIZE = 14;

export const PERSON_LINKS_ICONS: { [key: string]: React.ReactNode } = {
  [PersonLinksIcons.LINKEDIN]: <LinkedinIcon width={ICON_SIZE} height={ICON_SIZE} />,
  [PersonLinksIcons.TELEGRAM]: <TelegramIcon width={ICON_SIZE} height={ICON_SIZE} />,
  [PersonLinksIcons.MS_TEAMS]: <MsTeamsIcon width={ICON_SIZE} height={ICON_SIZE} />,
};
